import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { createTranslator } from './i18n';
import { DICTIONARIES } from './languages';

const Ctx = createContext({ t: (k)=>k, lang: 'en', setLang: ()=>{} });

export function I18nProvider({ children, defaultLang = 'en' }) {
  const initial = (() => {
    try {
      const saved = localStorage.getItem('bf_lang');
      if (saved && DICTIONARIES[saved]) return saved;
    } catch {}
    const nav = navigator.language?.split('-')[0];
    return DICTIONARIES[nav] ? nav : defaultLang;
  })();

  const [lang, setLang] = useState(initial);

  const translator = useMemo(() => {
    const inst = createTranslator({ dictionaries: DICTIONARIES, defaultLang });
    inst.setLang(lang);
    return inst;
  }, [lang, defaultLang]);

  useEffect(() => translator.setLang(lang), [translator, lang]);

  const value = useMemo(() => ({ t: translator.t, lang, setLang }), [translator, lang]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useI18n() { return useContext(Ctx); }
